export const QUIZ_PAGE = `/quiz/:id(\\d+)?`
